// Auth Mutations

export const setAuthUserData = (state, payload) => {
  state.authUserData = payload
}

export const resetAuthUserData = state => {
  state.authUserData = {}
}

export const setAuthToken = (state, payload) => {
  state.authToken = payload
}

export const setLoginCashiersList = (state, payload) => {
  state.loginCashiersList = payload
}
